import * as THREE from "three";

export default function light(scene) {
    const ambientLight = new THREE.AmbientLight(0xffffff, 0);
    scene.add(ambientLight);

    const keyLight = new THREE.DirectionalLight(0xffffff, 5.16);
    keyLight.position.set(29.1, 1.6, -25.9);
    keyLight.castShadow = true;
    keyLight.shadow.mapSize.width = 4096;
    keyLight.shadow.mapSize.height = 4096;
    keyLight.shadow.camera.near = 0.1;
    keyLight.shadow.camera.far = 50;
    keyLight.shadow.bias = -0.00009;
    scene.add(keyLight);

    const fillLight = new THREE.DirectionalLight(0xffffff, 0);
    fillLight.position.set(-5, 3, -4);
    scene.add(fillLight);

    return { ambientLight, keyLight, fillLight };
}
